export default __webpack_public_path__ + "static/media/logo-horiz.a3dc975c.png";